import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { builtFor, notFor } from '../data/content';
export function WhoItIsFor() {
  return <section id="fit" aria-labelledby="fit-title" className="border-b border-white/5 bg-ink-800" data-id="element-338" data-mp="i2iuxrr9e963">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-339" data-mp="d2ec3v2vp2cp">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-340" data-mp="87h6ky4t5b4k">
          Fit
        </p>
        <h2 id="fit-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-341" data-mp="15rbudy73az5g">
          Who it is for.
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-342" data-mp="vx1r3lgm0gfy">
          This is a response system for teams with real lead volume and real lead spend. If
          the phone is already ringing and appointments are the bottleneck, you are in the
          right place. If lead flow itself is the problem, we will tell you straight.
        </p>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-343" data-mp="b9fo2o0kinh9">
          <div className="rounded-xl border border-brand/35 bg-ink-700 p-7 sm:p-8" data-id="element-344" data-mp="g6xn9mos9oc2">
            <h3 className="font-display text-xl font-semibold tracking-tight text-brand" data-id="element-345" data-mp="g4uvoy7zfn58">
              Built for
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-346" data-mp="688f4lmovi90">
              {builtFor.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white/75" data-id="element-347" data-mp="3onajdblalc3z">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-348" data-mp="3tdr29b7vtpxq" />
                  <span className="leading-relaxed" data-id="element-349" data-mp="3eqec1974qw10">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-white/10 bg-ink-700 p-7 sm:p-8" data-id="element-350" data-mp="35o51ijbv32nm">
            <h3 className="font-display text-xl font-semibold tracking-tight text-white/70" data-id="element-351" data-mp="35q9d7ng055yg">
              Not for
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-352" data-mp="1g6rg1e1rtkhn">
              {notFor.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white/55" data-id="element-353" data-mp="1bgb1fqm7rstp">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-white/35" aria-hidden="true" data-id="element-354" data-mp="1behq3y0nokfd" />
                  <span className="leading-relaxed" data-id="element-355" data-mp="11jg1d3aalkdb">{item}</span>
                </li>)}
            </ul>
            <p className="mt-7 border-t border-white/10 pt-6 text-sm leading-relaxed text-white/70" data-id="element-356" data-mp="1z53zbsmecaqy">
              We do not sell leads. We stop you from losing the ones you already pay for.
            </p>
          </div>
        </div>
      </div>
    </section>;
}